import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
	component: () => import('../views/HomeView.vue')
  },
  {
    path: '/aboutus/introduce',
    name: 'introduce',
    component: () => import('../views/aboutus/introduce.vue')
  },
  {
    path: '/aboutus/joinus',
    name: 'joinus',
    component: () => import('../views/aboutus/joinus.vue')
  },
  {
    path: '/news/list',
    name: 'newsList',
    component: () => import('../views/news/list.vue')
  },
  {
    path: '/news/details',
    name: 'newsDesc',
    component: () => import('../views/news/details.vue')
  },
  {
    path: '/study/list',
    name: 'studyList',
    component: () => import('../views/study/list.vue')
  },
  {
    path: '/study/details',
    name: 'studyDesc',
    component: () => import('../views/study/details.vue')
  },
  {
    path: '/activity/list',
    name: 'activityList',
    component: () => import('../views/activity/list.vue')
  },
  {
    path: '/activity/exhibition',
    name: 'exhibition',
    component: () => import('../views/activity/exhibition.vue')
  },
  {
    path: '/activity/company',
    name: 'company',
    component: () => import('../views/activity/company.vue')
  },
  {
    path: '/activity/product',
    name: 'product',
    component: () => import('../views/activity/product.vue')
  },
  {
    path: '/foundparty/list',
    name: 'foundpartyList',
    component: () => import('../views/foundparty/list.vue')
  },
  {
    path: '/foundparty/details',
    name: 'foundpartyDesc',
    component: () => import('../views/foundparty/details.vue')
  },
  {
    path: '/pilotplatform/list',
    name: 'pilotplatformList',
    component: () => import('../views/pilotplatform/list.vue')
  },
  {
    path: '/pilotplatform/details',
    name: 'pilotplatformDesc',
    component: () => import('../views/pilotplatform/details.vue')
  },
  {
    path: '/VideoDetail',
    name: 'videoDesc',
    component: () => import('../views/VideoDetail.vue')
  },
  {
    path: '/events/list',
    name: 'eventsList',
    component: () => import('../views/events/list.vue')
  },
  {
    path: '/events/details',
    name: 'eventsDesc',
    component: () => import('../views/events/details.vue')
  },
  {
    path: '/train/list',
    name: 'trainList',
    component: () => import('../views/train/list.vue')
  },
  {
    path: '/train/details',
    name: 'trainDesc',
    component: () => import('../views/train/details.vue')
  },
  {
    path: '/exhibition/live',
    name: 'exhibitionLive',
    component: () => import('../views/exhibition/live.vue')
  },
  {
    path: '/exhibition/cloud',
    name: 'exhibitionCloud',
    component: () => import('../views/exhibition/cloud.vue')
  },
  {
    path: '/exhibition/offline',
    name: 'exhibitionOffline',
    component: () => import('../views/exhibition/offline.vue')
  },
  {
    path: '/exhibition/details',
    name: 'exhibitionDesc',
    component: () => import('../views/exhibition/details.vue')
  },
  {
    path: '/company/list',
    name: 'companyList',
    component: () => import('../views/company/list.vue')
  },
]

const router = new VueRouter({
    routes,
    scrollBehavior (to, from, savedPosition) {
      return { x: 0, y: 0 }
    }
})

export default router
